import FileGroupDataProcessingModal from './FileGroupDataProcessingModal'

export default FileGroupDataProcessingModal
